import * as React from 'react';
import {Avatar, Box, Button, Divider, List, ListItem, ListItemAvatar, ListItemText,} from '@mui/material';
import {makeStyles} from '@mui/styles';
import {Link} from 'react-router-dom';
import {useGetList, usePermissions} from 'react-admin';
import {subDays} from 'date-fns';
import {getFormattedDateString} from "../DateHelpers";
import {useTranslate} from 'react-admin';
import {useScope} from '../scope/ScopeContext';

const NewChildren = () => {
    const classes = useStyles();

    const translate = useTranslate();
    const {permissions} = usePermissions();
    const {umbrellaExternalId, charityExternalId} = useScope();
    // umbrella_id is an admin-only concept server-side (same gate as useScopedFilter.js) —
    // a charity/umbrella-role user with a stale persisted umbrella scope must not send it,
    // or the v2 endpoint 403s them outright.
    const isAdmin = permissions === 'admin';

    const aMonthAgo = subDays(new Date(), 30);
    aMonthAgo.setDate(aMonthAgo.getDate() - 30);
    aMonthAgo.setHours(0);
    aMonthAgo.setMinutes(0);
    aMonthAgo.setSeconds(0);
    aMonthAgo.setMilliseconds(0);

    const filter = {};
    if (isAdmin && umbrellaExternalId != null) filter.umbrella_id = umbrellaExternalId;
    if (charityExternalId != null) filter.charity_external_id = charityExternalId;

    const {data: children} = useGetList(
        'children',
        {
            sort: {field: 'create_date_time', order: 'DESC'},
            pagination: {page: 0, perPage: 5},
            filter,
        },
    );

    if (!children) return null;

    return (
        <div>
            <div>{translate('Last children onboarded')}</div>
            <hr />
            <List>
                {children
                    ? children.map((record) => (
                        <div key={record.id}>
                            <ListItem
                                button
                                to={`/children/${record.id}/show`}
                                component={Link}
                                key={record.id}
                                style={{height: 60}}
                            >
                                <ListItemAvatar>
                                    <Avatar
                                        src={`${process.env.REACT_APP_CDN_URL}/${record.profile_image_thumbnail}?size=32x32`}/>
                                </ListItemAvatar>
                                <ListItemText
                                    primary={[getFormattedDateString(record.create_date_time, 'D MMM YYYY'), `${record.name} (${record.charity_name})`].filter(Boolean).join(' - ')}
                                />
                            </ListItem>
                            <Divider light={true}/>
                        </div>
                    ))
                    : null}
            </List>
            <Box flexGrow="1">&nbsp;</Box>
            <Button
                className={classes.link}
                component={Link}
                to="/children"
                size="small"
                color="primary"
            >
                <Box p={1} className={classes.linkContent}>
                    {translate('Show all children')}
                </Box>
            </Button>
        </div>
    );
};

const useStyles = makeStyles(theme => ({
    link: {
        borderRadius: 0,
    },
    linkContent: {
        color: theme.palette.primary.main,
    },
}));

export default NewChildren;
